import ApiService from '../../../../../../../services/ApiService'
import Utils from '../../../../../../../Utils/FormatDate'
import InstitutionInactive from '../../../../../Institutions/components/institutionInactive/institutionInactive.vue'
import DepartmentInactive from '../../../../../Department/deparmentInactive/departmentInactive.vue'

export default {
  props: {
    calledId: String,
    institutionIdProp: String,
  },

  components: {
    InstitutionInactive,
    DepartmentInactive,
  },

  async created() {
    window.scrollTo(0, 0)
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.currentCalled.requesterCellPhone = this.userLogged.cellPhoneNumber
    await this.getInstitutions()

    this.institutionId = this.institutionIdProp

    const institution = this.institutions.find(
      (x) => x.id == this.institutionId
    )
    this.institutionInactive = institution.status == 1

    await this.getEquipments()
    await this.getDepartments()
    if (this.calledId) {
      this.getCalled()
    } else {
      this.user = this.userLogged
    }
    await this.getUnidades()
  },

  data: () => ({
    institution: {},
    searchEquipment: null,
    searchEquipmentPropertyCode: null,
    errorMessage: '',
    message: '',
    showSuccess: false,
    loading: false,
    institutionLoading: false,
    unidadeLoading: false,
    equipmentLoading: false,
    disapproveLoading: false,
    firstValid: true,
    alterDialog: false,
    changedData: false,
    isEditing: false,
    error: false,
    disapprove: false,
    institutionInactive: false,
    departmentInactive: false,
    buttonDisabled: false,
    departmentName: null,
    serviceTime: null,
    resolutionTime: null,
    stepServiceOrder: null,
    stepServiceOrderDate: null,
    calledCreatedAt: null,
    calledStatus: null,
    institutionId: null,
    institutions: [],
    unidadeId: null,
    unidades: [],
    equipmentId: null,
    equipments: [],
    equipmentsFiltered: [],
    equipmentSelected: {},
    userLogged: {},
    user: {},
    categories: [
      {
        text: 'Equipamento',
        value: 0,
      },
      {
        text: 'Setor',
        value: 1,
      },
    ],
    currentCalled: {
      id: 0,
      requesterCellPhone: '',
      request: '',
      statusDescription: '',
      disapprovedJustification: '',
    },
    institutionRules: [(v) => !!v || 'Instituição é requerida'],
    unidadeRules: [(v) => !!v || 'Unidade é requerida'],
    requestRules: [
      (v) => !!v || 'Solicitação/Reclamação é requerida',
      (v) =>
        v.length <= 500 ||
        'Solicitação/Reclamação deve ter no máximo 500 caracteres',
    ],
    apiService: new ApiService(),
    departmentLoading: false,
    departments: [],
    unidadeLoading: false,
    unidades: [],
    urgentTypes: [
      {
        text: 'Alta',
        value: 0,
      },
      {
        text: 'Média',
        value: 1,
      },
      {
        text: 'Baixa',
        value: 2,
      },
      {
        text: 'Neutra',
        value: 3,
      },
    ],
  }),

  computed: {
    buttonText() {
      return this.isEditing ? 'Atualizar' : 'Adicionar'
    },
  },

  methods: {
    async getDepartments() {
      this.departmentLoading = true

      await this.apiService
        .get(`department/list/${this.institutionId}`)
        .then((response) => {
          this.departments = response.content
          this.departmentLoading = false
        })
    },

    close() {
      sessionStorage.clear()
      if (this.changedData) {
        this.alterDialog = true
      } else {
        this.$router.push('/big-data')
      }
    },

    closeDialog() {
      this.changedData = false
      this.close()
    },

    showSuccessAlert(message) {
      this.message = message
      this.showSuccess = true
      window.scrollTo(0, 0)

      setTimeout(() => {
        this.showSuccess = false
        this.closeDialog()
      }, 1000)
    },

    newServiceOrder() {
      sessionStorage.clear()
      sessionStorage.setItem('called', JSON.stringify(this.currentCalled))
      this.$router.push('/newServiceOrder')
    },

    openServiceOrder() {
      const serviceOrder = this.currentCalled.serviceOrder
      this.$router.push(`/editServiceOrder/${serviceOrder.id}`)
    },

    async getCalled() {
      await this.apiService
        .get(`called/${this.institutionId}/${this.calledId}`)
        .then((response) => {
          this.currentCalled = response.content
          this.equipmentId = response.content.equipmentId
          this.institutionId = response.content.institutionId
          this.getUnidades()
          this.unidadeId = response.content.unidadeId
          this.calledCreatedAt = this.formatDate(response.content.createdAt)
          if (response.content.equipment) {
            this.querySelectionsEquipment(
              response.content.equipment.identification
            )
            this.departmentInactive =
              response.content.equipment.department.status == 1
          }
          this.user = response.content.userRequester
          switch (response.content.calledStatus) {
            case 0:
              this.calledStatus = 'Chamado enviado'
              break
            case 1:
              this.calledStatus = 'Em andamento'
              break
            case 2:
              this.calledStatus = 'Fechado'
              break
            case 3:
              this.calledStatus = 'Reprovado'
              break
          }

          if (response.content.serviceOrder != null) {
            this.getLastStep(response.content.serviceOrder.services)
          }
          this.buttonDisabled =
            this.institution.userType > 2 &&
            this.userLogged.id != this.user.id &&
            this.institution.userType != 8

          this.isEditing = true
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          if (err.status === 404) {
            this.$router.push('/calleds')
          }

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async getInstitutions() {
      this.institutionLoading = true

      await this.apiService.get('institution/list').then((response) => {
        this.institutions = response.content
        this.institutionLoading = false
      })
    },

    async getUnidades() {
      this.unidadeLoading = true

      let url = 'unidade/list'

      if (this.institutionId) {
        url = `unidade/list/${this.institutionId}`
      }

      await this.apiService.get(url).then((response) => {
        this.unidades = response.content
        this.unidadeLoading = false
      })
    },

    async getEquipments() {
      this.equipmentLoading = true

      await this.apiService
        .get(`equipment/list/${this.institutionId}`)
        .then((response) => {
          this.equipments = response.content
          this.equipmentLoading = false
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async getEquipmentById() {
      if (this.equipmentId) {
        await this.apiService
          .get(`equipment/${this.institutionId}/${this.equipmentId}`)
          .then((response) => {
            this.equipmentSelected = response.content
            this.unidadeId = response.content.unidadeId
          })
        await this.getDepartment()
        this.getTimes()
      }
      return
    },

    async getDepartment() {
      await this.apiService
        .get(`department/${this.equipmentSelected.departmentId}`)
        .then((response) => {
          this.departmentName = response.content.name
        })
    },

    getTimes() {
      if (
        this.equipmentSelected.criticality >= 3 &&
        this.equipmentSelected.criticality < 12
      ) {
        this.serviceTime =
          this.equipmentSelected.unidade.serviceTimeEquipmentLowCriticality
        this.resolutionTime =
          this.equipmentSelected.unidade.resolutionTimeEquipmentLowCriticality
      } else if (
        this.equipmentSelected.criticality >= 12 &&
        this.equipmentSelected.criticality < 19
      ) {
        this.serviceTime =
          this.equipmentSelected.unidade.serviceTimeEquipmentMediumCriticality
        this.resolutionTime =
          this.equipmentSelected.unidade.resolutionTimeEquipmentMediumCriticality
      } else if (
        this.equipmentSelected.criticality >= 19 &&
        this.equipmentSelected.criticality < 28
      ) {
        this.serviceTime =
          this.equipmentSelected.unidade.serviceTimeEquipmentHighCriticality
        this.resolutionTime =
          this.equipmentSelected.unidade.resolutionTimeEquipmentHighCriticality
      } else {
        this.serviceTime = null
        this.resolutionTime = null
      }
    },

    getLastStep(services) {
      const lastStep = services[services.length - 1]

      if (lastStep) {
        switch (lastStep.statusStepServiceOrder) {
          case 0:
            this.stepServiceOrder = 'Manutenção terceirizada in loco'
            break
          case 1:
            this.stepServiceOrder = 'Manutenção terceirizada externa'
            break
          case 2:
            this.stepServiceOrder = 'Manutenção interna'
            break
          case 3:
            this.stepServiceOrder = 'Aguardando peça'
            break
          case 4:
            this.stepServiceOrder = 'Aguardando orçamento'
            break
          case 5:
            this.stepServiceOrder = 'Aguardando avaliação externa'
            break
          case 6:
            this.stepServiceOrder = 'Aguardando aprovação de orçamento'
          case 7:
            this.stepServiceOrder = 'Aguardando liberação do setor'
          default:
            return null
        }

        this.stepServiceOrderDate = this.formatDate(lastStep.dateTimeStartStep)
      }
    },

    async submit() {
      this.loading = true
      if (this.$refs.firstForm.validate()) {
        const called = {
          Id: this.currentCalled.id,
          InstitutionId: this.institutionId,
          UnidadeId: this.unidadeId,
          UserRequesterId: this.userLogged.id,
          RequesterCellPhone: this.currentCalled.requesterCellPhone,
          Request: this.currentCalled.request,
          EquipmentId: this.equipmentId,
          StatusDescription: this.currentCalled.statusDescription,
          DisapprovedJustification: this.currentCalled.disapprovedJustification,
          ServiceOrderId: this.currentCalled.serviceOrderId,
          CalledStatus: this.currentCalled.calledStatus,
          departmentId: this.currentCalled.departmentId,
          calledLevelUrgent: this.currentCalled.calledLevelUrgent,
          category: this.currentCalled.category,
        }

        let url = 'called/add'

        if (this.isEditing) {
          url = 'called/edit'
        }

        await this.apiService
          .post(url, called)
          .then((response) => {
            this.showSuccessAlert(response.content)
          })
          .catch((err) => {
            window.scrollTo(0, 0)
            this.errorMessage = err.message
            this.error = true

            setTimeout(() => {
              this.error = false
            }, 4000)
          })
      } else {
        this.$refs.firstForm.$el.scrollIntoView({ behavior: 'smooth' })
      }

      this.loading = false
      this.changedData = false
    },

    async disapproveCalled() {
      this.disapproveLoading = true
      const called = {
        Id: this.currentCalled.id,
        DisapprovedJustification: this.currentCalled.disapprovedJustification,
      }

      await this.apiService
        .post('called/disapprove', called)
        .then((response) => {
          this.showSuccessAlert(response.content)
        })
      this.disapproveLoading = false
    },

    formatDateTime(date) {
      return Utils.dateTime(date)
    },

    async querySelectionsEquipment(value) {
      this.equipmentLoading = true

      setTimeout(() => {
        this.equipmentsFiltered = this.equipments.filter((e) => {
          return e.identification.indexOf(value) > -1
        })

        this.equipmentLoading = false
        if (this.equipmentId) {
          this.getEquipmentById()
        }
      }, 500)
    },

    async querySelectionsEquipments(value) {
      this.equipmentLoading = true

      setTimeout(() => {
        this.equipmentsFiltered = this.equipments.filter((e) => {
          if (e.propertyCode != null) {
            return e.propertyCode.indexOf(value) > -1
          }
        })
        this.equipmentLoading = false
        if (this.equipmentId) {
          this.getEquipmentById()
        }
      }, 500)
    },

    formatDate(date) {
      return Utils.dateTime(date)
    },
  },

  watch: {
    currentCalled: {
      deep: true,
      handler() {
        if (this.currentCalled.calledStatus < 2) {
          this.changedData = true
        }
      },
    },

    searchEquipment(value) {
      value &&
        value !== this.equipmentId &&
        this.querySelectionsEquipment(value)
    },

    searchEquipmentPropertyCode(value) {
      value &&
        value !== this.equipmentId &&
        this.querySelectionsEquipments(value)
    },
  },
}
